import React, { FC, useEffect, useRef } from 'react';
import { Backdrop, Box, Typography, useTheme } from '@mui/material';
import { useUnit } from 'effector-react';
import CircularProgress from '@mui/material/CircularProgress';
import { ReactSVG } from 'react-svg';
import { resetColumnList } from '../../model/Columns';
import { Routers } from './routers';

import { DragColumnContextMemo } from './DragColumnContext';
import { $currentUuid } from './model';
import { ContainerGrid } from '../../components/ContainerGrid';
import { $isDeskDontAccess, $pendingCardOrColumn } from '../../model/card';
import { $boardError } from '../../model/board';
import NotFound from '../../../pages/errors/NotFound';
import errorSvg from '../../../assets/icons/errors/404.svg';

const Loading: FC = () => {
  const theme = useTheme();
  return (
    <Backdrop
      sx={{
        color: theme.palette.info.light,
      }}
      open
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export const Error: FC = () => (
    <Box width="100%" display="flex" flexDirection="column" height="100vh">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <ReactSVG src={errorSvg} />
        <Typography
          sx={{
            marginTop: '40px',
            fontWeight: '700',
            fontSize: '20px',
          }}
        >
          Страницы нет или у вас нет прав
        </Typography>
      </Box>
    </Box>
  )
export const Desk: FC = () => {
  useEffect(
    () => () => {
      resetColumnList();
    },
    [],
  );

  const currentUuid = useUnit($currentUuid);

  const lastUid = useRef(currentUuid);

  const pendingCardOrColumn = useUnit($pendingCardOrColumn);
  const [boardError,isDeskDontAccess] = useUnit([$boardError,$isDeskDontAccess]);

  const pending = lastUid.current !== currentUuid && pendingCardOrColumn;
  const notFoundDesk = boardError || isDeskDontAccess;

  useEffect(() => {
    lastUid.current = currentUuid;
  }, [pending]);

  return (
    <ContainerGrid minWidth={notFoundDesk?"100%":undefined}>
      <Routers />

      {pending ? <Loading /> : notFoundDesk?<Error/>:<DragColumnContextMemo />}
    </ContainerGrid>
  );
};

export const DeskMemo = React.memo(Desk);
